const downloadDirectoryPdf = async (directoryDocument) => {
  const response = await fetch(directoryDocument.downloadUrl, {
    method: "GET",
    credentials: "same-origin",
    headers: {
      Accept: "application/pdf",
    },
  });

  if (!response.ok) {
    let message = "Unable to download the membership directory";
    try {
      const error = await response.json();
      message = error.message || message;
    } catch (error) {
      // The server did not return a JSON error response.
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = window.document.createElement("a");
  link.href = objectUrl;
  link.download = directoryDocument.originalName || "membership-directory.pdf";
  window.document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
};

export default downloadDirectoryPdf;
